import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';

import { useAppDispatch, useAppSelector } from '@STORE/index';

import { deleteTagModalSlice, DeleteTagModalDispatchParams, DeleteTagModalState } from '@REDUCERS';

function createDeleteTagModalHook() {
    return function useDeleteTagModal(equalityFn?: EqualityFn<DeleteTagModalState>) {
        const state = useAppSelector((store) => store.deleteTagModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: (params: DeleteTagModalDispatchParams) => dispatch(deleteTagModalSlice.actions.open(params)),
            close: () => dispatch(deleteTagModalSlice.actions.close()),
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

export default createDeleteTagModalHook();
